// import React, { useState } from "react";

// const holes = [
//   {
//     number: 1,
//     men: "450 yards",
//     women: "361 yards",
//     par: 5,
//     handicap: 2,
//     desc: "A long opening hole with a straight fairway. Good for a strong drive to start your round.",
//   },
//   {
//     number: 2,
//     men: "383 yards",
//     women: "307 yards",
//     par: 4,
//     handicap: 9,
//     desc: "A moderate-length par 4. Play smart to set up a good approach to the green.",
//   },
//   {
//     number: 3,
//     men: "388 yards",
//     women: "300 yards",
//     par: 4,
//     handicap: 5,
//     desc: "Slightly longer par 4. Good accuracy off the tee is important.",
//   },
//   {
//     number: 4,
//     men: "507 yards",
//     women: "389 yards",
//     par: 5,
//     handicap: 4,
//     desc: "A long par 5 with challenges along the way. Best chance to reach the green in three shots.",
//   },
//   {
//     number: 5,
//     men: "398 yards",
//     women: "338 yards",
//     par: 4,
//     handicap: 3,
//     desc: "One of the tougher par 4s. A solid tee shot is key to make par.",
//   },
//   {
//     number: 6,
//     men: "351 yards",
//     women: "295 yards",
//     par: 4,
//     handicap: 1,
//     desc: "The hardest hole on the course. Requires accuracy and careful shot placement.",
//   },
//   {
//     number: 7,
//     men: "147 yards",
//     women: "79 yards",
//     par: 3,
//     handicap: 6,
//     desc: "Short par 3. Good chance for a birdie with a precise tee shot.",
//   },
//   {
//     number: 8,
//     men: "263 yards",
//     women: "220 yards",
//     par: 4,
//     handicap: 8,
//     desc: "A short par 4. Play safe or try to reach the green with one big shot.",
//   },
//   {
//     number: 9,
//     men: "133 yards",
//     women: "107 yards",
//     par: 3,
//     handicap: 7,
//     desc: "A short finishing hole. A nice chance to end the round with a good score.",
//   },
// ];

// const images = [
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758730968/9_hole_golf_course_mdgxpx.jpg", // First image
//   // "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758648419/golf_course_wrhpbv.jpg", // Second image
// ];

// const hoelsImages = [
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/1-01_gcjfrq.jpg",
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/2-01_gms3li.jpg",
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/3-01_jpopoh.jpg",
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/4-01_gbxugg.jpg",
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/5-01_jm6pua.jpg",
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/6-01_ipisvl.jpg",
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/7-01_wzfwey.jpg",
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/8-01_rozlxo.jpg",
//   "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/9-01_bgoxhy.jpg",
// ];

// const GolfCourse = () => {
//   const [current, setCurrent] = useState(0);
//   const [modalImg, setModalImg] = useState(null);

//   const prevSlide = () => {
//     setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//   };

//   const nextSlide = () => {
//     setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 flex flex-col">
//       {/* Page Title */}
//       <h1 className="text-4xl font-bold text-center py-6 text-green-700 tracking-wide">
//         9 Hole Golf Course
//       </h1>

//       <div className="flex flex-1 flex-col md:flex-row">
//         {/* Left Section - Timeline */}
//         <div className="w-full md:w-1/2 h-[80vh] overflow-y-auto flex flex-col items-center bg-gray-100 p-4">
//           <div className="relative h-full w-full max-w-xl">
//             {/* Image */}
//             <img
//               src={images[current]}
//               alt={`Slide ${current + 1}`}
//               className="rounded-xl shadow-lg w-full h-full object-cover cursor-pointer"
//               onClick={() => setModalImg(images[current])}
//             />

//             {/* Left Button */}
//             <button
//               onClick={prevSlide}
//               className="absolute top-1/2 left-3 -translate-y-1/2 bg-black text-white p-2 rounded-full shadow hover:bg-gray-700"
//             >
//               ❮
//             </button>

//             {/* Right Button */}
//             <button
//               onClick={nextSlide}
//               className="absolute top-1/2 right-3 -translate-y-1/2 bg-black text-white p-2 rounded-full shadow hover:bg-gray-700"
//             >
//               ❯
//             </button>
//           </div>

//           {/* Dots indicator */}
//           <div className="flex space-x-2 mt-4">
//             {images.map((_, i) => (
//               <span
//                 key={i}
//                 onClick={() => setCurrent(i)}
//                 className={`h-3 w-3 rounded-full cursor-pointer ${
//                   current === i ? "bg-green-600" : "bg-gray-400"
//                 }`}
//               ></span>
//             ))}
//           </div>
//           <p className="mt-6 text-gray-700 text-justify leading-relaxed px-4">
//             Rangpur Golf and Country Club (RGCC) features a beautifully designed
//             golf course surrounded by lush greenery and serene landscapes. The
//             wide, open fairways are perfectly maintained, offering a smooth and
//             enjoyable experience for golfers of all skill levels. Natural water
//             bodies and tree-lined boundaries enhance the course’s beauty while
//             adding a bit of challenge to each hole. The layout includes several
//             greens and tees (like G-1 to G-9 and T-1 to T-9), thoughtfully
//             arranged across the vast area. Its peaceful environment, combined
//             with scenic views, makes it not just a golf destination but also a
//             relaxing retreat. RGCC is truly a gem for both golfers and nature
//             lovers in the heart of Rangpur.
//           </p>
//         </div>

//         {/* Right Section - Scrollable with Slider */}
//         <div className="w-full md:w-1/2 px-6 py-8  h-[80vh] overflow-y-scroll">
//           <div className="relative border-l border-green-300">
//             {holes.map((hole) => (
//               <div key={hole.number} className="mb-10 ml-6">
//                 {/* Circle */}
//                 <span className="absolute -left-3 flex items-center justify-center w-6 h-6 bg-green-600 rounded-full ring-4 ring-white text-white text-sm font-bold">
//                   {hole.number}
//                 </span>
//                 <div className="p-5 bg-white rounded-xl shadow-md hover:shadow-lg transition">
//                   <h2 className="text-xl font-semibold text-green-700">
//                     Hole {hole.number}
//                   </h2>
//                   <p className="text-sm text-gray-600 mt-1">
//                     Men’s Tee: <span className="font-medium">{hole.men}</span> |
//                     Women’s Tee:{" "}
//                     <span className="font-medium">{hole.women}</span>
//                   </p>
//                   <p className="text-sm text-gray-600">
//                     Par: <span className="font-medium">{hole.par}</span> |
//                     Handicap Index:{" "}
//                     <span className="font-medium">{hole.handicap}</span>
//                   </p>
//                   <p className="mt-2 text-gray-700 leading-relaxed">
//                     {hole.desc}
//                   </p>
//                   {/* See Image Button */}
//                   <button
//                     onClick={() =>
//                       setModalImg(hoelsImages[hole.number - 1] || images[0])
//                     }
//                     className="mt-3 bg-green-600 text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
//                   >
//                     See Image
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Modal */}
//       {modalImg && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
//           <img
//             src={modalImg}
//             alt="Large Preview"
//             className="max-w-4xl max-h-[90vh] rounded-lg shadow-lg"
//           />
//           <button
//             onClick={() => setModalImg(null)}
//             className="absolute top-5 right-5 bg-white text-black p-2 rounded-full w-10 h-10 shadow hover:bg-gray-200"
//           >
//             ✕
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default GolfCourse;

import React, { useEffect, useRef, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  X,
  Flag,
  Map,
  Target,
  Trophy,
  Sparkles,
  Maximize2,
  Compass,
  Mountain,
  TreePine,
  Wind,
  Calendar,
  Users,
  ArrowRight,
  Star,
} from "lucide-react";

const holes = [
  {
    number: 1,
    men: "450 yards",
    women: "361 yards",
    par: 5,
    handicap: 2,
    desc: "A long opening hole with a straight fairway. Good for a strong drive to start your round.",
    difficulty: "Medium",
    icon: <Flag className="w-5 h-5" />,
    color: "from-emerald-500 to-lime-500",
  },
  {
    number: 2,
    men: "383 yards",
    women: "307 yards",
    par: 4,
    handicap: 9,
    desc: "A moderate-length par 4. Play smart to set up a good approach to the green.",
    difficulty: "Easy",
    icon: <Target className="w-5 h-5" />,
    color: "from-blue-500 to-cyan-500",
  },
  {
    number: 3,
    men: "388 yards",
    women: "300 yards",
    par: 4,
    handicap: 5,
    desc: "Slightly longer par 4. Good accuracy off the tee is important.",
    difficulty: "Medium",
    icon: <Compass className="w-5 h-5" />,
    color: "from-amber-500 to-orange-500",
  },
  {
    number: 4,
    men: "507 yards",
    women: "389 yards",
    par: 5,
    handicap: 4,
    desc: "A long par 5 with challenges along the way. Best chance to reach the green in three shots.",
    difficulty: "Hard",
    icon: <Mountain className="w-5 h-5" />,
    color: "from-purple-500 to-pink-500",
  },
  {
    number: 5,
    men: "398 yards",
    women: "338 yards",
    par: 4,
    handicap: 3,
    desc: "One of the tougher par 4s. A solid tee shot is key to make par.",
    difficulty: "Hard",
    icon: <Wind className="w-5 h-5" />,
    color: "from-red-500 to-rose-500",
  },
  {
    number: 6,
    men: "351 yards",
    women: "295 yards",
    par: 4,
    handicap: 1,
    desc: "The hardest hole on the course. Requires accuracy and careful shot placement.",
    difficulty: "Very Hard",
    icon: <TreePine className="w-5 h-5" />,
    color: "from-gray-700 to-gray-900",
  },
  {
    number: 7,
    men: "147 yards",
    women: "79 yards",
    par: 3,
    handicap: 6,
    desc: "Short par 3. Good chance for a birdie with a precise tee shot.",
    difficulty: "Easy",
    icon: <Star className="w-5 h-5" />,
    color: "from-green-500 to-emerald-500",
  },
  {
    number: 8,
    men: "263 yards",
    women: "220 yards",
    par: 4,
    handicap: 8,
    desc: "A short par 4. Play safe or try to reach the green with one big shot.",
    difficulty: "Easy",
    icon: <Target className="w-5 h-5" />,
    color: "from-indigo-500 to-blue-500",
  },
  {
    number: 9,
    men: "133 yards",
    women: "107 yards",
    par: 3,
    handicap: 7,
    desc: "A short finishing hole. A nice chance to end the round with a good score.",
    difficulty: "Medium",
    icon: <Flag className="w-5 h-5" />,
    color: "from-lime-500 to-emerald-500",
  },
];

const images = [
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758730968/9_hole_golf_course_mdgxpx.jpg",
];

const holeImages = [
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/1-01_gcjfrq.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/2-01_gms3li.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/3-01_jpopoh.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/4-01_gbxugg.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909165/5-01_jm6pua.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/6-01_ipisvl.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/7-01_wzfwey.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/8-01_rozlxo.jpg",
  "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758909166/9-01_bgoxhy.jpg",
];

const GolfCourse = () => {
  const [current, setCurrent] = useState(0);
  const [modalImg, setModalImg] = useState(null);
  const [selectedHole, setSelectedHole] = useState(null);

  const courseRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (courseRef.current) {
        courseRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const openHoleModal = (holeNumber) => {
    setSelectedHole(holeNumber);
    setModalImg(holeImages[holeNumber - 1] || images[0]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-8 sm:py-12 md:py-16 lg:py-20 overflow-hidden">
        {/* Background Blobs */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-8 -right-8 sm:-top-12 sm:-right-12 md:-top-24 md:-right-24 w-32 h-32 sm:w-48 sm:h-48 md:w-96 md:h-96 bg-emerald-600/20 rounded-full blur-xl sm:blur-2xl md:blur-3xl"></div>
          <div className="absolute -bottom-8 -left-8 sm:-bottom-12 sm:-left-12 md:-bottom-24 md:-left-24 w-32 h-32 sm:w-48 sm:h-48 md:w-96 md:h-96 bg-lime-600/20 rounded-full blur-xl sm:blur-2xl md:blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Logo/Icon */}
          <div className="inline-flex items-center justify-center mb-3 sm:mb-4 md:mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-md sm:blur-lg md:blur-lg opacity-50"></div>
              <div className="relative w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center shadow-lg sm:shadow-xl md:shadow-2xl">
                <Flag className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 text-white" />
              </div>
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-3 sm:mb-4 md:mb-6 px-2">
            Championship{" "}
            <span className="relative inline-block">
              <span className="relative z-10">9-Hole Course</span>
              {/* <span className="absolute bottom-0.5 sm:bottom-1 md:bottom-2 left-0 w-full h-1.5 sm:h-2 md:h-3 bg-gradient-to-r from-emerald-400 to-lime-400 -rotate-1"></span> */}
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-emerald-100 max-w-xs sm:max-w-lg md:max-w-2xl lg:max-w-3xl mx-auto mb-4 sm:mb-6 md:mb-8 px-2">
            Experience the beauty and challenge of our meticulously designed
            golf course in Rangpur
          </p>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 md:gap-4 lg:gap-6">
            <div className="flex items-center gap-1 sm:gap-2 text-emerald-200 text-xs sm:text-sm md:text-base">
              <Map className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
              <span>3,066 Total Yards</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="sm:hidden text-emerald-300 text-xs">•</div>
            <div className="flex items-center gap-1 sm:gap-2 text-emerald-200 text-xs sm:text-sm md:text-base">
              <Trophy className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
              <span>Par 36</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="sm:hidden text-emerald-300 text-xs">•</div>
            <div className="flex items-center gap-1 sm:gap-2 text-emerald-200 text-xs sm:text-sm md:text-base">
              <Calendar className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
              <span>Year-Round Play</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-6 sm:py-8 md:py-10 lg:py-12">
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-10 xl:gap-12">
          {/* Left Column - Course Image & Description */}
          <div className="space-y-6 sm:space-y-8">
            {/* Course Image Carousel */}
            <div className="relative group">
              <div className="absolute -inset-2 sm:-inset-3 md:-inset-4 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-xl sm:rounded-2xl md:rounded-3xl blur-lg sm:blur-xl opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
              <div className="relative rounded-lg sm:rounded-xl md:rounded-2xl overflow-hidden shadow-xl sm:shadow-2xl">
                <img
                  src={images[current]}
                  alt={`Course View ${current + 1}`}
                  className="w-full h-48 sm:h-64 md:h-80 lg:h-96 object-cover cursor-pointer transform transition-transform duration-700 group-hover:scale-105"
                  onClick={() => setModalImg(images[current])}
                />

                {/* Navigation Buttons */}
                <button
                  onClick={prevSlide}
                  className="absolute left-2 sm:left-3 md:left-4 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-gray-800 hover:bg-white hover:scale-110 transition-all duration-300 shadow-md sm:shadow-lg"
                  aria-label="Previous slide"
                >
                  <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                </button>

                <button
                  onClick={nextSlide}
                  className="absolute right-2 sm:right-3 md:right-4 top-1/2 -translate-y-1/2 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center text-gray-800 hover:bg-white hover:scale-110 transition-all duration-300 shadow-md sm:shadow-lg"
                  aria-label="Next slide"
                >
                  <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
                </button>

                {/* View Fullscreen Button */}
                <button
                  onClick={() => setModalImg(images[current])}
                  className="absolute top-2 sm:top-3 md:top-4 right-2 sm:right-3 md:right-4 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/30 hover:scale-110 transition-all duration-300"
                  aria-label="View fullscreen"
                >
                  <Maximize2 className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5" />
                </button>
              </div>

              {/* Dots Indicator */}
              <div className="flex justify-center gap-1.5 sm:gap-2 mt-3 sm:mt-4">
                {images.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrent(i)}
                    className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                      current === i
                        ? "bg-gradient-to-r from-emerald-500 to-lime-500 w-6 sm:w-8"
                        : "bg-gray-300 hover:bg-gray-400"
                    }`}
                    aria-label={`Go to slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>

            {/* Course Description */}
            <div className="bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 lg:p-8 shadow-lg sm:shadow-xl border border-emerald-100">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                  <Flag className="w-5 h-5 sm:w-6 sm:h-6 text-emerald-600" />
                </div>
                <div>
                  <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">
                    Course Overview
                  </h2>
                  <p className="text-gray-600 text-sm sm:text-base">
                    Experience golfing excellence
                  </p>
                </div>
              </div>

              <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">
                Rangpur Golf and Country Club (RGCC) features a beautifully
                designed golf course surrounded by lush greenery and serene
                landscapes. The wide, open fairways are perfectly maintained,
                offering a smooth and enjoyable experience for golfers of all
                skill levels.
              </p>

              <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                Natural water bodies and tree-lined boundaries enhance the
                course's beauty while adding a bit of challenge to each hole.
                The layout includes several greens and tees (like G-1 to G-9 and
                T-1 to T-9), thoughtfully arranged across the vast area. Its
                peaceful environment, combined with scenic views, makes it not
                just a golf destination but also a relaxing retreat. RGCC is
                truly a gem for both golfers and nature lovers in the heart of
                Rangpur.
              </p>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-100">
                <div className="text-center">
                  <div className="text-xl sm:text-2xl font-bold text-emerald-600">
                    9
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600">Holes</div>
                </div>
                <div className="text-center">
                  <div className="text-xl sm:text-2xl font-bold text-emerald-600">
                    36
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600">Par</div>
                </div>
                <div className="text-center">
                  <div className="text-xl sm:text-2xl font-bold text-emerald-600">
                    3,066
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600">Yards</div>
                </div>
                <div className="text-center">
                  <div className="text-xl sm:text-2xl font-bold text-emerald-600">
                    72.5
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600">Rating</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Holes Timeline */}
          <div className="relative">
            {/* Timeline Header */}
            <div className="mb-6 sm:mb-8">
              <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                <Sparkles className="w-5 h-5 sm:w-6 sm:h-6 text-emerald-500" />
                <h2
                  ref={courseRef}
                  className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900"
                >
                  Hole-by-Hole Guide
                </h2>
              </div>
              <p className="text-gray-600 text-sm sm:text-base">
                Navigate through our championship holes with detailed
                specifications and tips
              </p>
            </div>

            {/* Timeline Container */}
            <div className="relative">
              {/* Vertical Timeline Line - Hidden on mobile, visible on sm+ */}
              <div className="hidden sm:block absolute left-6 sm:left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-emerald-300 via-lime-300 to-emerald-300"></div>

              {/* Holes */}
              {holes.map((hole) => (
                <div
                  key={hole.number}
                  className="relative mb-6 sm:mb-8 last:mb-0 group"
                >
                  {/* Timeline Dot - Adjusted for mobile */}
                  <div className="absolute left-0 sm:left-6 transform -translate-x-1/2 z-10">
                    <div className="relative">
                      <div
                        className={`absolute inset-0 bg-gradient-to-r ${hole.color} rounded-full blur-md opacity-30`}
                      ></div>
                      <div className="relative w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full bg-white border-3 sm:border-4 border-emerald-500 flex items-center justify-center shadow-lg sm:shadow-xl md:shadow-2xl">
                        <div className="text-emerald-600 scale-75 sm:scale-90 md:scale-100">
                          {hole.icon}
                        </div>
                      </div>
                      <div className="absolute -bottom-1.5 sm:-bottom-2 left-1/2 transform -translate-x-1/2 px-2 py-0.5 sm:px-3 sm:py-1 bg-emerald-500 text-white text-xs sm:text-sm font-bold rounded-full shadow-md sm:shadow-lg">
                        {hole.number}
                      </div>
                    </div>
                  </div>

                  {/* Hole Card */}
                  <div className="ml-14 sm:ml-24">
                    <div className="bg-white/90 backdrop-blur-sm rounded-lg sm:rounded-xl md:rounded-2xl p-4 sm:p-5 md:p-6 shadow-lg sm:shadow-xl hover:shadow-2xl transition-all duration-500 border border-gray-100 sm:border-2 hover:border-emerald-100 group-hover:-translate-y-1">
                      {/* Header */}
                      <div className="flex flex-col sm:flex-row sm:items-start justify-between mb-3 sm:mb-4">
                        <div className="mb-3 sm:mb-0">
                          <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-1 sm:mb-2">
                            Hole {hole.number}
                          </h3>
                          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 md:gap-4 text-xs sm:text-sm">
                            <div className="flex items-center gap-1 sm:gap-2">
                              <Users className="w-3 h-3 sm:w-4 sm:h-4 text-gray-500" />
                              <span className="text-gray-700">
                                Men: <strong>{hole.men}</strong>
                              </span>
                            </div>
                            <div className="flex items-center gap-1 sm:gap-2">
                              <Users className="w-3 h-3 sm:w-4 sm:h-4 text-gray-500" />
                              <span className="text-gray-700">
                                Women: <strong>{hole.women}</strong>
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Difficulty Badge */}
                        <div className="px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-xs sm:text-sm font-semibold bg-gradient-to-r from-emerald-50 to-lime-50 text-emerald-700 border border-emerald-100 self-start sm:self-center">
                          {hole.difficulty}
                        </div>
                      </div>

                      {/* Stats */}
                      <div className="flex gap-3 sm:gap-4 mb-3 sm:mb-4">
                        <div className="px-2 py-1.5 sm:px-3 sm:py-2 rounded-lg bg-gray-50 min-w-16 sm:min-w-20">
                          <div className="text-xs sm:text-sm text-gray-500">
                            Par
                          </div>
                          <div className="text-base sm:text-lg font-bold text-emerald-600">
                            {hole.par}
                          </div>
                        </div>
                        <div className="px-2 py-1.5 sm:px-3 sm:py-2 rounded-lg bg-gray-50 min-w-16 sm:min-w-20">
                          <div className="text-xs sm:text-sm text-gray-500">
                            Handicap
                          </div>
                          <div className="text-base sm:text-lg font-bold text-amber-600">
                            {hole.handicap}
                          </div>
                        </div>
                      </div>

                      {/* Description */}
                      <p className="text-gray-600 text-sm mb-4 sm:mb-6 leading-relaxed">
                        {hole.desc}
                      </p>

                      {/* Action Button */}
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-0">
                        <button
                          onClick={() => openHoleModal(hole.number)}
                          className="inline-flex items-center gap-1.5 sm:gap-2 text-emerald-600 hover:text-emerald-800 font-medium text-sm sm:text-base group/btn transition-colors duration-300"
                        >
                          <span>View Hole Layout</span>
                          <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4 group-hover/btn:translate-x-1 transition-transform" />
                        </button>

                        <div className="text-xs text-gray-500 text-right sm:text-left">
                          Click for detailed view
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Course Features */}
        <div className="mt-12 sm:mt-14 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
          <div className="bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 border border-emerald-100 shadow-md sm:shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center mb-3 sm:mb-4">
              <TreePine className="w-5 h-5 sm:w-6 sm:h-6 text-emerald-600" />
            </div>
            <h4 className="font-bold text-gray-900 text-sm sm:text-base md:text-lg mb-1 sm:mb-2">
              Natural Beauty
            </h4>
            <p className="text-gray-600 text-xs sm:text-sm">
              Lush greenery and serene landscapes
            </p>
          </div>
          <div className="bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 border border-emerald-100 shadow-md sm:shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br from-blue-50 to-cyan-50 flex items-center justify-center mb-3 sm:mb-4">
              <Target className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
            </div>
            <h4 className="font-bold text-gray-900 text-sm sm:text-base md:text-lg mb-1 sm:mb-2">
              Strategic Design
            </h4>
            <p className="text-gray-600 text-xs sm:text-sm">
              Challenging yet fair for all skill levels
            </p>
          </div>
          <div className="bg-white/90 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 border border-emerald-100 shadow-md sm:shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center mb-3 sm:mb-4">
              <Calendar className="w-5 h-5 sm:w-6 sm:h-6 text-amber-600" />
            </div>
            <h4 className="font-bold text-gray-900 text-sm sm:text-base md:text-lg mb-1 sm:mb-2">
              Year-Round Play
            </h4>
            <p className="text-gray-600 text-xs sm:text-sm">
              Perfect conditions throughout the year
            </p>
          </div>
        </div>
      </div>

      {/* Modal for Images */}
      {modalImg && (
        <div className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center p-2 sm:p-3 md:p-4">
          <div className="relative max-w-4xl lg:max-w-5xl xl:max-w-6xl w-full">
            <img
              src={modalImg}
              alt="Large Preview"
              className="w-full max-h-[85vh] sm:max-h-[90vh] object-contain rounded-lg sm:rounded-xl md:rounded-2xl shadow-2xl"
            />

            {/* Close Button */}
            <button
              onClick={() => {
                setModalImg(null);
                setSelectedHole(null);
              }}
              className="absolute top-2 right-2 sm:top-3 sm:right-3 md:top-4 md:right-4 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
              aria-label="Close modal"
            >
              <X className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
            </button>

            {/* Hole Info if available */}
            {selectedHole && (
              <div className="absolute bottom-2 left-2 right-2 sm:bottom-3 sm:left-3 sm:right-3 md:bottom-4 md:left-4 md:right-4 bg-black/50 backdrop-blur-sm rounded-lg sm:rounded-xl p-2 sm:p-3 md:p-4 text-white">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-0">
                  <div>
                    <h3 className="text-base sm:text-lg md:text-xl font-bold">
                      Hole {selectedHole} -{" "}
                      {holes[selectedHole - 1]?.title || "Layout"}
                    </h3>
                    <p className="text-emerald-200 text-xs sm:text-sm md:text-base">
                      {holes[selectedHole - 1]?.men} (Men) •{" "}
                      {holes[selectedHole - 1]?.women} (Women)
                    </p>
                  </div>
                  <div className="text-left sm:text-right">
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-emerald-300">
                      Par {holes[selectedHole - 1]?.par}
                    </div>
                    <div className="text-xs sm:text-sm md:text-base">
                      Handicap: {holes[selectedHole - 1]?.handicap}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GolfCourse;
